import React from 'react';
import { Skeleton, Space } from 'antd';

interface MethodSkeletonProps {
    /** Number of skeleton items to display */
    count?: number;
}

/**
 * Reusable skeleton component for loading states in method lists
 * (shipping methods, payment methods). Displays a configurable number
 * of skeleton items with avatar and text lines to simulate list items.
 */
export const MethodSkeleton: React.FC<MethodSkeletonProps> = ({ count = 3 }) => {
    return (
        <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="method-skeleton-item">
                    <Skeleton
                        active
                        avatar={{ shape: 'square', size: 40 }}
                        paragraph={{ rows: 1, width: '60%' }}
                        title={{ width: '40%' }}
                    />
                </div>
            ))}
        </Space>
    );
};
